import axios from 'axios';
import { useContext, useRef } from "react";
import { Context } from "./Reducers/Store";
import { useTokenHelper } from './Hooks/useTokenHelper';

export const WithAxios = ({ children }) => {
    const [, dispatch] = useContext(Context);
    const requests = useRef(0);
    const tokenHelper = useTokenHelper();

    if (global._interceptor1 != null) axios.interceptors.request.eject(global._interceptor1);
    if (global._interceptor2 != null) axios.interceptors.response.eject(global._interceptor2);

    global._interceptor1 = axios.interceptors.request.use(
        async request => {
            if (!request.metadata?.skipAuth) {
                const jwtToken = await tokenHelper.getToken();
                if (jwtToken != null)
                    request.headers.Authorization = 'Bearer ' + jwtToken;
            }

            if (!request.metadata?.ignoreLoading) {
                dispatch({ type: 'SET_LOADING', payload: true });
                requests.current += 1;
            }

            return request;
        }, error => {
            return Promise.reject(error);
        }
    );

    global._interceptor2 = axios.interceptors.response.use(
        response => {
            if (!response.config?.metadata?.ignoreLoading) {
                requests.current -= 1;
                if (requests.current <= 0) {
                    requests.current = 0;
                    dispatch({ type: 'SET_LOADING', payload: false });
                }
            }
            return response;
        },
        async error => {
            if (!error.config?.metadata?.ignoreLoading) {
                requests.current -= 1;
                if (requests.current <= 0) {
                    requests.current = 0;
                    dispatch({ type: 'SET_LOADING', payload: false });
                }
            }

            const status = error.response?.status ?? error.status;
            if (status === 401) {
                const url = error.config?.url ?? '';
                const isAuthEndpoint = url.includes('/auth/login') || url.includes('/auth/refresh');
                const canRetry = !isAuthEndpoint && !error.config?._retry && !error.config?.metadata?.skipAuth;
                if (canRetry) {
                    error.config._retry = true;
                    const newToken = await tokenHelper.refreshAccessToken();
                    if (newToken) {
                        error.config.headers = {
                            ...(error.config.headers ?? {}),
                            Authorization: 'Bearer ' + newToken
                        };
                        return axios(error.config);
                    }
                }

                if (!isAuthEndpoint) {
                    dispatch({ type: 'SET_LOGGED', payload: null });
                    error.message = 'SESSION_EXPIRED';
                }
            }

            return Promise.reject(error);
        }
    );

    return children;
};
